import { RemoveAssignmentsDialog } from "../staff/RemoveAssignmentsDialog";
import type { StaffAssignmentRow } from "../staff/types";

interface StaffManageDialogsProps {
  readonly selectedRows: readonly StaffAssignmentRow[];
  readonly removeOpen: boolean;
  readonly onRemoveOpenChange: (open: boolean) => void;
  readonly removePending: boolean;
  readonly removeError: string | null;
  readonly onConfirmRemove: () => void;
}

/** The admin-only confirmation of the memberships section: remove the selected assignments. */
export function StaffManageDialogs(props: StaffManageDialogsProps) {
  return (
    <RemoveAssignmentsDialog
      open={props.removeOpen}
      onOpenChange={props.onRemoveOpenChange}
      names={props.selectedRows.map((r) => r.entityName)}
      isPending={props.removePending}
      error={props.removeOpen ? props.removeError : null}
      onConfirm={props.onConfirmRemove}
    />
  );
}
